"use client"

import PointList from "@/app/pointexchange/_list";
import SectionTitle from "@/components/etc/section_title";
import { useTranslations } from "next-intl";

export default function PointExchange({ isSwipe }: {  isSwipe?: boolean }){
    const p = useTranslations("PageTitle")

    return (
        <div className="">
            <div style={{padding: "8px 0 0"}}>
                <SectionTitle shortCut={`/pointexchange/partnership/`}> <span>{p("제휴스폰")}</span></SectionTitle>
                <PointList type={2} sideBoard isSwipe />
            </div>
        </div>
    )
}